import React, { useState, useEffect } from "react";
import axios from "axios";
import WeatherForecastDay from "./WeatherForecastDay";
import "./WeatherForecast.css";

export default function WeatherForecast(props) {
  let [loaded, setLoaded] = useState(false);
  let [forecast, setForecast] = useState(null);

  // update forecast if the coords change
  useEffect(() => {
    // set loaded to false
    setLoaded(false);
  }, [props.coords]);

  function showForecast(response) {
    setForecast(response.data.daily);
    setLoaded(true);
  }

  if (loaded) {
    return (
      <div className="WeatherForecast">
        {forecast.map(function (dailyForecast, index) {
          if (index < 5) {
            return (
              <div className="WeatherForecastDaily" key={index}>
                <WeatherForecastDay data={dailyForecast} />
              </div>
            );
          } else {
            return null;
          }
        })}
      </div>
    );
  } else {
    let apiKey = "8d3bfd549605ffe7b5b97d941806e42e";
    let apiEndpoint = "https://api.openweathermap.org/data/2.5/";
    let longtitude = props.coords.lon;
    let latitude = props.coords.lat;
    let apiUrl = `${apiEndpoint}onecall?lat=${latitude}&lon=${longtitude}&appid=${apiKey}&units=metric`;

    axios.get(apiUrl).then(showForecast);

    return null;
  }
}
